/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 15:04:00
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
import { mapActions } from 'vuex';
import sNumberValidation from '@/services/sNumberValidation';
import sDate from '@/services/sDate';

// CHILD COMPONENTS ////////////////////////////////////////////////////////////
import Card from '@/components/Common/Card';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'RechargesHistorySearchTerms',

  components: { Card },

  props: ['rechargesList', 'isLoadingData'],

  data() {
    return {
      searchCategory: 'daysPriorToCurrent',
      dateStart: null,
      dateEnd: null,
      daysAmount: 1,
      sort: 'desc',
      sortBy: 'date',
    };
  },

  beforeMount() {
    this.setInitialValues();
  },

  watch: {
    searchCategory(newValue) {
      // ustawienie defaultowej daty początkowej i końcowej po wybraniu opcji zakresu dat
      if (newValue === 'dateFromTo') {
        this.dateStart = sDate.getYesterdayDate();
        this.dateEnd = sDate.getYesterdayDate();
      }
    },
  },

  computed: {
    dateStartFormatted() {
      return this.dateStart ? sDate.formatDate(this.dateStart) : null;
    },
    dateEndFormatted() {
      return this.dateEnd ? sDate.formatDate(this.dateEnd) : null;
    },
    dateDaysFromToday() {
      return sDate.getDateFromToday(this.daysAmount);
    },
    dateYesterdayFormatted() {
      return sDate.formatDate(sDate.getYesterdayDate());
    },
    disabledStartDates() {
      return { from: sDate.getYesterdayDate() };
    },
    disabledEndDates() {
      return this.dateStart ?
        { to: this.dateStart, from: sDate.addMonths(this.dateStart, 6) }
        : { from: sDate.getYesterdayDate() };
    },
  },

  methods: {
    ...mapActions(['setRechargesTerms', 'getRechargesList']),
    /**
    * Metoda sprawdza czy podana przez użytkownika ilość dni nie przekracza maksymalnej ilości dni,
    * a także nie pozwala mu wpisać więcej cyfr niż ich ilość w maksymalnej ilości dni.
    *
    * @method validateDaysAmount()
    * @param brak
    * @return brak
    * @access public
    */
    validateDaysAmount() {
      const maxCharacters = 3;
      const maxDaysAmount = 180;
      const number = sNumberValidation.validateNumber(this.daysAmount, maxCharacters);
      this.daysAmount = number > maxDaysAmount ? maxDaysAmount : number;
    },
    /**
    * Metoda przekazujące odpowiednie dane do store ze względu na aktualnie zaznaczoną opcję
    * w formularzu (radio-button). Użytkownik ma do wyboru tylko dwie opcje więc zastosowano if-else.
    *
    * @method submitSearchTerms()
    * @param brak
    * @return brak
    * @access public
    */
    submitSearchTerms() {
      if (this.searchCategory === 'daysPriorToCurrent') {
        this.setRechargesTerms({
          dateStart: this.dateDaysFromToday,
          dateEnd: this.dateYesterdayFormatted,
          sort: this.sort,
          sortBy: this.sortBy,
        })
          .then(this.getRechargesList);
      } else {
        this.setRechargesTerms({
          dateStart: this.dateStartFormatted,
          dateEnd: this.dateEndFormatted,
          sort: this.sort,
          sortBy: this.sortBy,
        })
          .then(this.getRechargesList);
      }
    },
    /**
    * Metoda ustawia wartość daty końcowej po uprzednim wybraniu daty początkowej.
    * Możliwe jest kilka scenariuszy opisanych poniżej w ciele funkcji.
    *
    * @method setDateEndValue()
    * @param brak
    * @return brak
    * @access public
    */
    setDateEndValue() {
      const yesterday = sDate.getYesterdayDate();
      const maxMonthsMiliseconds = -13148730000;
      const maxMonthsAmount = 6;
      // gdy data końcowa jest już wybrana
      if (this.dateEnd) {
        // jeśli data początkowa wcześniejsza niż 6 miesięcy od daty końcowej
        if ((this.dateStart - this.dateEnd) < maxMonthsMiliseconds) {
          // ustaw datę końcową na najpóźniejszą możliwą (6 miesięcy później niż data początkowa)
          this.dateEnd = sDate.addMonths(this.dateStart, maxMonthsAmount);
          // jeśli data początkowa jest późniejsza niż data końcowa
        } else if ((this.dateStart - this.dateEnd) > 0) {
          // ustaw datę końcową taką samą jak początkowa
          this.dateEnd = this.dateStart;
        }
        // jeśli data końcowa nie jest wybrana, a data początkowa wcześniejsza niż 6 miesięcy od wczoraj
      } else if ((this.dateStart - yesterday) < maxMonthsMiliseconds) {
        // ustaw datę końcową na najpóźniejszą możliwą (6 miesięcy później niż data początkowa)
        this.dateEnd = sDate.addMonths(this.dateStart, maxMonthsAmount);
        // jeśli wszystkie pozostałe warunki nie spełniły się
      } else {
        // ustaw datę końcową na wczoraj
        this.dateEnd = yesterday;
      }
    },
    /**
    * Metoda ustawia wartość poczatkową zmiennej daysAmount na 'wczoraj'.
    * Dzięki temu zgadza się ona ze wstępnie podanymi wynikami wyszukiwania.
    *
    * @method setInitialValues()
    * @param brak
    * @return brak
    * @access public
    */
    setInitialValues() {
      const today = new Date();
      this.daysAmount = today.getDate() - 1;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Recharges/RechargesHistorySearchTerms/component.js